import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../axiosConfig';
import './knowledge_base.css';

const KBCategoryView = () => {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCategory();
  }, [slug]);

  const loadCategory = async () => {
    try {
      const response = await api.get(`/kb/categories/${slug}`);
      setCategory(response.data.category);
      setArticles(response.data.articles);
      setLoading(false);
    } catch (error) {
      console.error('Error loading category:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="kb-loading">
        <div className="spinner"></div>
        <p>Loading category...</p>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="category-not-found">
        <h1>Category Not Found</h1>
        <Link to="/kb">Back to Knowledge Base</Link>
      </div>
    );
  }

  return (
    <div className="kb-category-page">
      <div className="container">
        {/* Breadcrumb */}
        <nav className="breadcrumb">
          <Link to="/kb">Knowledge Base</Link>
          <span className="separator">›</span>
          <span className="current">{category.name}</span>
        </nav>

        {/* Category Header */}
        <header className="category-header">
          <h1>{category.name}</h1>
          {category.description && <p>{category.description}</p>}
          <p className="article-count">{articles.length} articles</p>
        </header>

        {/* Articles List */}
        <div className="category-articles">
          {articles.length > 0 ? (
            articles.map(article => (
              <Link
                key={article.id}
                to={`/kb/articles/${article.slug}`}
                className="article-card"
              >
                <h3>{article.title}</h3>
                <p>{article.excerpt}</p>
                <div className="article-meta">
                  <span className="views">{article.views} views</span>
                </div>
              </Link>
            ))
          ) : (
            <p>No articles in this category yet.</p>
          )}
        </div>

        {/* Back Button */}
        <div className="category-footer">
          <Link to="/kb" className="btn-back">
            <i className="fas fa-arrow-left"></i> Back to All Categories
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KBCategoryView;